import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.scss';

/**
 * ButtonBack component
 * @param {object} props - The component props.
 * @param {Function} props.onClick - The click handler.
 */
export const ButtonBack = ({ onClick }) => (
  <button
    data-testid="button-back"
    aria-label="Back"
    type="button"
    onClick={onClick}
    className={styles.back}
  >
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.3411 5.31714L6.80267 11.6806C6.61005 11.8548 6.61005 12.1451 6.80267 12.3193L13.3411 18.6829" stroke="#2A2A2A" strokeWidth="1.8" strokeMiterlimit="10" strokeLinecap="round" />
    </svg>
  </button>
);

ButtonBack.propTypes = {
  onClick: PropTypes.func.isRequired,
};
